import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const MIN_SPOTS = 3;
export function ScarcityBar() {
  const [spots, setSpots] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpots(s => s > MIN_SPOTS ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spots) / TOTAL_SPOTS * 100;
  return <div className="mt-6 rounded-2xl border border-rose/20 bg-rose-soft p-4 text-left" data-id="element-267" data-mp="2b5fauj9uewwc">
      <div className="flex items-start gap-2" data-id="element-268" data-mp="2g7ee7t5l1tta">
        <FlameIcon className="mt-0.5 h-5 w-5 shrink-0 text-rose" aria-hidden="true" data-id="element-269" data-mp="226brde6rkfhb" />
        <p className="text-[15px] font-bold leading-snug text-ink" data-id="element-270" data-mp="2755619xsecj2">
          Only <span className="text-rose" data-id="element-271" data-mp="275eu2rz9u9m4">{spots} spots left</span> at the promotional price
        </p>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-inset ring-rose/15" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-272" data-mp="cmbivxggxhp">
        <div className="h-full rounded-full bg-rose transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-273" data-mp="2zj6z0024wdjy" />
      </div>
      <p className="mt-2 flex justify-between text-xs font-semibold text-muted" data-id="element-274" data-mp="38ewejsgwidpf">
        <span data-id="element-275" data-mp="2kn8yk5l6gn1x">{Math.round(filled)}% claimed</span>
        <span data-id="element-276" data-mp="2kq3jdy83s9vv">Price returns to normal when spots run out</span>
      </p>
    </div>;
}